let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("16N9J")).then(() => parcelRequire('49cNF'));